import { api } from "@/lib/api";

export interface DashboardAnalytics {
  statusDistribution: Record<string, number>;
  serviceDistribution: Record<string, number>;
  revenueByService: Record<string, number>;
  storageTypeDistribution: Record<string, number>;
  submissionSuccessRate: number;
  totalPipelineValue: number;
  avgProjectValue: number;
  projectsTrend: { name: string; value: number }[];
  avgCycleTime: {
    draftToSubmitted: number;
    submittedToCompleted: number;
  };
  totalProjects: number;
}

export const analyticsApi = {
  getDashboardAnalytics: async (): Promise<DashboardAnalytics> => {
    const response = await api.get<DashboardAnalytics>("/analytics/dashboard");
    return response.data;
  },
};
